export function canonicalChatRoomName(roomName: string): string {
  const trimmed = roomName.trim()
  if (!trimmed.includes(":")) return trimmed
  return trimmed.split(":").filter(Boolean).sort().join(":")
}

export function chatRoomLookupCandidates(roomName: string): string[] {
  const trimmed = roomName.trim()
  if (!trimmed) return []

  const canonical = canonicalChatRoomName(trimmed)
  const parts = trimmed.split(":").filter(Boolean)
  const candidates = new Set<string>([trimmed, canonical])

  if (parts.length === 2) {
    candidates.add(parts.join(":"))
    candidates.add([parts[1], parts[0]].join(":"))
  }

  return Array.from(candidates)
}

export function decodeChatRoomParam(raw: string): string {
  const trimmed = raw.trim()
  if (!trimmed) return ""
  if (!trimmed.includes("%")) return canonicalChatRoomName(trimmed)
  try {
    return canonicalChatRoomName(decodeURIComponent(trimmed))
  } catch {
    return canonicalChatRoomName(trimmed)
  }
}
